import { Injectable } from '@angular/core';

const STORAGE_KEY_PREFIX = 'announcement_seen_';

@Injectable({ providedIn: 'root' })
export class AnnouncementStorage {
  isSeen(id: string): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY_PREFIX + id) === 'true';
    } catch {
      return false;
    }
  }

  markSeen(id: string): void {
    try {
      localStorage.setItem(STORAGE_KEY_PREFIX + id, 'true');
    } catch {}
  }
}
